import React from 'react'

import type { PresentationNavContextValue } from './PresentationNavContext'
import PresentationNavContext from './PresentationNavContext'

export interface PresentationNavContextProviderProps extends PresentationNavContextValue {}

export default function PresentationNavContextProvider({ children, ...props }) {
  const childrenFn = children as (context: PresentationNavContextValue) => React.ReactNode

  const value = {
    ...props,
    // Derived, never passed in: a presentation with one page renders as a single continuous scroll
    // and its nav lists section titles; with more than one, each page is a tab (#21990). This was
    // hardcoded `true` for as long as v2 had no page level.
    isSinglePage: (props.presentation?.pages?.length ?? 0) <= 1
  }

  return (
    <PresentationNavContext.Provider value={value}>
      {typeof children === 'function' ? childrenFn(value) : children}
    </PresentationNavContext.Provider>
  )
}
